import { LegalLayout, H, P } from "./LegalLayout";

export default function TermsConditions() {
  return (
    <LegalLayout title="Terms & Conditions" updated="JUNE 2026" testId="terms-page">
      <div>
        <H>1. Acceptance of Terms</H>
        <P>By accessing this website or registering for the Veteran Fast-Track webinar, you agree to these Terms &amp; Conditions. If you do not agree, please do not use this site. This site is operated by Darren Gussick (NMLS# 122481), NEXA Mortgage LLC (NMLS# 1660690).</P>
      </div>
      <div>
        <H>2. Educational Purpose Only</H>
        <P>The webinar and all content on this site are for educational purposes only. Attendance does not constitute a loan application, loan approval, pre-approval, or a commitment to lend. No credit pull is required to attend. Results, approval, rates, and closing timelines are not guaranteed and depend on individual circumstances and applicable underwriting guidelines.</P>
      </div>
      <div>
        <H>3. SMS / Text Messaging Terms</H>
        <P>By providing your mobile number and opting in, you consent to receive text messages from Darren Gussick / NEXA Mortgage regarding your webinar registration, event reminders, and related homebuying education.</P>
        <P>• Message frequency varies.<br />• Message and data rates may apply.<br />• Reply STOP at any time to cancel and opt out of further messages.<br />• Reply HELP for assistance, or contact 407-550-5795 or dgussick@nexalending.com.<br />• Consent is not a condition of any purchase or service.<br />• Carriers are not liable for delayed or undelivered messages.</P>
        <P>Mobile opt-in data and consent will not be shared with third parties for marketing or promotional purposes.</P>
      </div>
      <div>
        <H>4. No Financial Advice</H>
        <P>Content presented is general information and is not financial, legal, or tax advice. You should consult qualified professionals regarding your individual situation before making any financial decisions.</P>
      </div>
      <div>
        <H>5. Intellectual Property</H>
        <P>All content on this site — text, graphics, logos, and design — is the property of its respective owners and may not be reproduced or distributed without written permission.</P>
      </div>
      <div>
        <H>6. Limitation of Liability</H>
        <P>To the fullest extent permitted by law, this site and the webinar are provided "as is" without warranties of any kind. We are not liable for any indirect, incidental, or consequential damages arising from your use of this site or attendance at the webinar.</P>
      </div>
      <div>
        <H>7. Licensing &amp; Compliance</H>
        <P>Darren Gussick NMLS# 122481. NEXA Mortgage LLC NMLS# 1660690. Licensed in Florida, Texas &amp; Pennsylvania. Equal Housing Opportunity. For licensing information, visit the NMLS Consumer Access website at nmlsconsumeraccess.org.</P>
      </div>
      <div>
        <H>8. Governing Law &amp; Changes</H>
        <P>These terms are governed by the laws of the United States and the applicable state of residence. We may update these Terms at any time; continued use of the site constitutes acceptance of the updated Terms. Questions: dgussick@nexalending.com · 407-550-5795.</P>
      </div>
    </LegalLayout>
  );
}
